import { http } from "services/http";

import type {
  PageSeo,
  PageSeoIdRequest,
  PageSeoIdResponse,
  PagesSeoListRequest,
  PagesSeoListResponse,
} from "models/pages.model";
import type { TradeSlug } from "models/trades.model";

const multipart = { headers: { contentType: "multipart/form-data" } };

export const pagesApi = {
  getData: (data?: PagesSeoListRequest) =>
    http.quiet().post<PagesSeoListResponse>("/api/pages-seo", data ? { ...data } : null),
  getSlugs: () => http.quiet().get<TradeSlug[]>("/api/trades-history/get-slugs"),
  // uri, title, description, content and the og_image file appended to a FormData;
  // `update` adds the id.
  createPage: (data: FormData) =>
    http.quiet().post<PageSeoIdResponse>("/api/pages-seo/add", data, multipart),
  getPage: (data: PageSeoIdRequest) => http.quiet().post<PageSeo>("/api/pages-seo/show", { ...data }),
  updatePage: (data: FormData) =>
    http.quiet().post<PageSeoIdResponse>("/api/pages-seo/update", data, multipart),
};
